import IconButtonDefault from './IconButton';

export default IconButtonDefault;



// WEBPACK FOOTER //
// ./src/client/Components/IconButton/index.js